// axios 配置
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";
//创建 axios 实例
let request = axios.create({
  // baseURL: "http://192.168.2.50:8999/jeecg-boot"
  baseURL: "https://evl.xinyixinedu.cn/jeecg-boot"
});

//拦截request的发送请求和响应请求，并做一定的配置
request.interceptors.request.use(
  //拦截发送请求，并给请求头信息headers加上token令牌s
  config => {
    let token = sessionStorage.getItem("token");
    if (token) {
      //把获取到的token放入cookie
      config.headers = {
        "X-Access-Token": token
      };
    }
    return config;
  },
  err => {
    Promise.reject(err);
  }
);
//拦截响应请求 ， 这里直接返回数据
request.interceptors.response.use(
  res => {
    if (res.data.code == 401) {
      //如果返回401，则跳转到登录页面
      Message.warning("请重新登录");
      sessionStorage.clear();
      router.push({
        path: "/signIn"
      });
    }
    return res;
  },
  err => {
    if (err.response.status == 401) {
      Message.warning("请重新登录");
      sessionStorage.clear();
      router.push({
        path: "/signIn"
      });
    }

    // Promise.reject(err)
  }
);

//给axios实例对象request添加postURL方法
request.postURL = function(url, data, option = {}) {
  //返回一个promise，实现异步处理
  return new Promise(function(resolve, reject) {
    request({
      url: url,
      method: "POST",
      data: data,
      ...option,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ...option.headers
      }
    })
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};

request.getURL = function(url, data, option = {}) {
  //返回一个promise，实现异步处理
  return new Promise(function(resolve, reject) {
    request({
      url: url,
      method: "GET",
      params: data,
      ...option,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ...option.headers
      }
    })
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};

request.CodegetURL = function(url, data, option = {}) {
  //返回一个promise，实现异步处理
  return new Promise(function(resolve, reject) {
    request({
      url: url,
      method: "GET",
      data: data,
      ...option,
      headers: {
        "Content-Type": "x-www-form-urlencoded;charset=UTF-8",
        ...option.headers
      }
    })
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};

request.coursegetURL = function(url, data, option = {}) {
  //返回一个promise，实现异步处理
  return new Promise(function(resolve, reject) {
    request({
      url: url,
      method: "GET",
      data: data,
      ...option,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        ...option.headers
      }
    })
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};
export default request;



// WEBPACK FOOTER //
// ./src/api/api.js